@import '../../styles/mixins/_btalk-mixins.scss';
@import '../../styles/variables/_btalk-variables.scss';

:host {
  display: block;
}

.brighttalk-search-form {
  width: 100%;

  .search-bar {
    font-size: 16px;
    position: relative;
    display: flex;
    will-change: border;
    //transition: border .35s ease-in;
    border: 1px solid $btalk_upper_navbar_bg;

    @media screen and (max-width: 887px) {
     width: 95%;
    }

    @media screen and (min-width: 888px ) {
     max-width: 486px;
    }

    &:hover {
     border-bottom-color: #a0a0a0;
    }

    .search-bar-input {
     font-family: $font__bt-reg;
     font-size: 16px;
     width: 100%;
     padding-left: 10px;
     border: 0;
     background-color: $nav-borders;
     color: $link-grey;  
     &:focus {
      background-color: $color__primary-button-text;
      outline: 0;
     }
     &::placeholder {
      font-family: $font__bt-light;
      color: $color__med-body;
      opacity: 0.5;
     }
    }

    .search-bar-icon {
     width: 16px;
     position: relative;
     top: calc(50% - 16px);
    }

    .search-bar-button {
     font-size: inherit;
     height: 40px;
     width: 42px;
     border: 0;
     outline: 0;
     background-color: $nav-borders;
     cursor: pointer;

     &:hover,
     &:focus {
      background-color: #F0F0F0;
     }
    }
  }

} // brighttalk-search-form
